import { Component, Input, ContentChildren, Output, EventEmitter } from '@angular/core';
import { isInt, toBoolean } from '../util/util';
import { NglTab } from './tab';
var NglTabs = (function () {
    function NglTabs() {
        this.type = 'default';
        this.selectedChange = new EventEmitter();
        this._titleCaps = true;
    }
    Object.defineProperty(NglTabs.prototype, "setSelected", {
        set: function (selected) {
            if (selected === this.selected)
                return;
            this.selected = selected;
            if (!this.tabs)
                return; // Wait for content to initialize
            this.activate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglTabs.prototype, "titleCaps", {
        get: function () {
            return this._titleCaps;
        },
        set: function (titleCaps) {
            this._titleCaps = toBoolean(titleCaps);
        },
        enumerable: true,
        configurable: true
    });
    NglTabs.prototype.ngAfterContentInit = function () {
        var _this = this;
        // Initial selection after all tabs are created
        this.activate();
        if (!this.activeTab) {
            setTimeout(function () { return _this.select(_this.tabs.first); });
        }
    };
    NglTabs.prototype.select = function (tab) {
        this.selectedChange.emit(tab);
    };
    NglTabs.prototype.move = function (evt, moves) {
        evt.preventDefault();
        var tabs = this.tabs.toArray();
        var selectedIndex = tabs.indexOf(this.activeTab);
        this.select(tabs[(tabs.length + selectedIndex + moves) % tabs.length]);
    };
    NglTabs.prototype.activate = function () {
        if (this.activeTab) {
            this.activeTab.active = false;
        }
        this.activeTab = this.findTab();
        if (this.activeTab) {
            this.activeTab.active = true;
        }
    };
    NglTabs.prototype.findTab = function (value) {
        if (value === void 0) { value = this.selected; }
        if (value instanceof NglTab) {
            return value;
        }
        if (isInt(value)) {
            return this.tabs.toArray()[+value];
        }
        return this.tabs.toArray().find(function (t) {
            return t.id && t.id === value;
        });
    };
    NglTabs.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-tabs',
                    template: "\n    <ul [ngClass]=\"'slds-tabs--' + type + '__nav'\" role=\"tablist\" (keydown.ArrowLeft)=\"move($event, -1)\" (keydown.ArrowRight)=\"move($event, 1)\"><li *ngFor=\"let tab of tabs\" [ngClass]=\"'slds-tabs--' + type + '__item'\" [class.slds-active]=\"tab.active\" [class.slds-text-title--caps]=\"titleCaps\" (click)=\"select(tab)\" role=\"presentation\"><a [nglInternalOutlet]=\"tab.heading\" [ngClass]=\"'slds-tabs--' + type + '__link'\" role=\"tab\" [attr.aria-selected]=\"tab.active\" [attr.tabindex]=\"tab.active ? 0 : 1\"></a></li></ul><div [ngClass]=\"'slds-tabs--' + type + '__content'\" role=\"tabpanel\"><ng-template [ngTemplateOutlet]=\"activeTab?.templateRef\"></ng-template></div>\n  ",
                },] },
    ];
    /** @nocollapse */
    NglTabs.ctorParameters = function () { return []; };
    NglTabs.propDecorators = {
        'type': [{ type: Input },],
        'tabs': [{ type: ContentChildren, args: [NglTab,] },],
        'setSelected': [{ type: Input, args: ['selected',] },],
        'selectedChange': [{ type: Output },],
        'titleCaps': [{ type: Input },],
    };
    return NglTabs;
}());
export { NglTabs };
//# sourceMappingURL=tabs.js.map